<div class="flex flex-col space-y-16">
  <!-- Change -->
  <section
    class="padding2 flex flex-col justify-center space-y-12 md:space-y-0 md:flex-row h-[640px]"
  >
    <div class="flex flex-col md:w-1/2 justify-center text-black space-y-6">
      <h1 class="text-2xl lg:text-5xl leading-tight">
        VoyageX Jobs — Your Maritime Career, Simplified. Your Crew, Managed.
      </h1>

      <p class="text-lg text-gray-700">
        VoyageX Jobs connects
        <strong>seafarers with top global employers</strong> and helps
        <strong> maritime companies hire skilled crews effortlessly </strong>
        through AI-powered recruitment.
      </p>

      <!-- <a
        href="https://voyagex.ai/contact-us/"
        class="w-fit bg-blue-600 px-6 py-2 text-white font-medium rounded-md hover:bg-blue-500 transition-all"
      >
        Contact us
      </a> -->
    </div>

    <div class="md:w-1/2 flex justify-center md:justify-end items-center">
      <img
        src="maritime-jobs.webp"
        alt="maritime-career"
        width="300"
        height="300"
        class="rounded-full w-[300px] md:w-[360px] lg:w-[400px]"
      />
    </div>
  </section>

  <section
    class="padding2 flex flex-col md:flex-row justify-between space-y-6 md:space-y-0 md:space-x-6"
  >
    <!-- Card for Seafarers -->
    <div
      class="border border-gray-200 rounded-md p-8 space-y-6 w-full lg:w-1/2 flex flex-col"
    >
      <img src="seafarer.svg" alt="seafarer_card_img" class="h-12 w-12" />

      <h2 class="text-xl text-black">
        For Seafarers: Advance Your Maritime Career
      </h2>
      <p class="text-base text-gray-700">
        Set sail for your next opportunity with verified shipping companies
        worldwide. Whether you're a
        <strong>Deck Officer, Marine Engineer, or Crew Member</strong>, VoyageX
        Jobs ensures a fast, secure, and hassle-free job search.
      </p>
      <ul class="text-sm text-gray-700 space-y-2">
        <li class="flex gap-2 before:content-['✅'] before:mr-1">
          <span
            ><strong>Access Exclusive Maritime Jobs</strong> – Find high-paying,
            verified opportunities.</span
          >
        </li>
        <li class="flex gap-2 before:content-['✅'] before:mr-1">
          <span
            ><strong>Get Hired Faster</strong> – AI-driven job matching connects
            you with the right employer.</span
          >
        </li>
        <li class="flex gap-2 before:content-['✅'] before:mr-1">
          <span
            ><strong>One Profile, Multiple Applications</strong> – Apply quickly
            with a seamless system.</span
          >
        </li>
        <li class="flex gap-2 before:content-['✅'] before:mr-1">
          <span
            ><strong>Stay Industry-Ready</strong> – Receive updates on
            certifications, job trends, and career growth.</span
          >
        </li>
      </ul>

      <a
        href="https://voyagex.ai/seafarer-app/"
        aria-label="Learn more about Seafarer App"
        class="text-base text-blue-700 hover:text-blue-600 hover:underline underline-offset-2"
      >
        Learn More About the Seafarer App
      </a>
    </div>

    <!-- Card for Maritime Companies -->
    <div
      class="border border-gray-200 rounded-md p-8 w-full lg:w-1/2 flex flex-col gap-6"
    >
      <div class="flex items-center">
        <img src="skilled.svg" alt="maritime_card_img" class="size-12" />
      </div>

      <h2 class="text-xl text-black">
        <span>For Maritime Companies: Hire Skilled Seafarers with Ease</span>
        <span class="block"></span>
      </h2>

      <p class="text-base text-gray-700">
        Streamline your <strong>seafarer recruitment</strong> with VoyageX
        Jobs—an AI-powered platform designed for efficient hiring, compliance,
        and talent management in the maritime industry.
      </p>
      <ul class="text-sm text-gray-700 space-y-2">
        <li class="flex gap-2 before:content-['✅'] before:mr-1">
          <span
            ><strong>Global Talent Pool</strong> – Connect with pre-vetted,
            skilled seafarers.</span
          >
        </li>
        <li class="flex gap-2 before:content-['✅'] before:mr-1">
          <span
            ><strong>AI-Powered Hiring</strong> – Reduce time-to-hire with
            intelligent matching.</span
          >
        </li>
        <li class="flex gap-2 before:content-['✅'] before:mr-1">
          <span
            ><strong>Regulatory Compliance Simplified</strong> – Ensure
            adherence to maritime labor laws.</span
          >
        </li>
        <li class="flex gap-2 before:content-['✅'] before:mr-1">
          <span
            ><strong>Seamless Integration</strong> – Sync with VoyageX AI’s Crew
            Management Software for end-to-end workforce management.</span
          >
        </li>
      </ul>

      <a
        href="https://voyagex.ai/crew-management-software/"
        aria-label="Learn more about Crew Management Software"
        class="text-base rounded-md text-blue-700 hover:text-blue-600 hover:underline underline-offset-2"
      >
        Learn More About Crew Management Software
      </a>
    </div>
  </section>

  <section class="padding2 flex flex-col w-full py-16 pb-32">
    <div class="space-y-6">
      <h2 class="text-xl text-black">Why Choose VoyageX Jobs?</h2>
      <ul class="text-base text-gray-700 space-y-2">
        <li class="flex items-center gap-2 before:content-['🌍'] before:mr-1">
          <span
            ><strong>Trusted by Global Maritime Companies</strong> – Work with
            verified employers and top talent.</span
          >
        </li>
        <li class="flex items-center gap-2 before:content-['🚀'] before:mr-1">
          <span
            ><strong>AI-Driven Efficiency</strong> – Intelligent job matching
            and streamlined hiring.</span
          >
        </li>
        <li class="flex items-center gap-2 before:content-['📊'] before:mr-1">
          <span
            ><strong>Industry-Specific Platform</strong> – Built exclusively for
            maritime professionals.</span
          >
        </li>
        <li class="flex items-center gap-2 before:content-['🔐'] before:mr-1">
          <span
            ><strong>Secure & Reliable</strong> – Trusted platform ensuring
            transparency and compliance.</span
          >
        </li>
        <li class="flex items-center gap-2 before:content-['📩'] before:mr-1">
          <span>
            <a href="https://voyagex.ai/contact-us/">
              <strong class="text-blue-600 hover:underline">Contact Us</strong>
            </a>
            to explore how VoyageX Jobs can elevate your maritime hiring or job
            search.
          </span>
        </li>
      </ul>
    </div>
  </section>
</div>
